import {
  chakra,
  Text,
} from '@chakra-ui/react';
import React from 'react';
import formatPrice from '../../../services/formatPrice';

const PriceLabel = ({ price, unit }: { price?: number, unit?: string }) => {
  if (!price && !unit) return null;
  const formattedPrice = formatPrice(price);
  return (
    <Text whiteSpace="nowrap"><b>{formattedPrice}</b> <chakra.span color="gray.500">{unit}</chakra.span></Text>
  );
};

export default PriceLabel;
